export default "__VITE_ASSET__b81b359e__"